import { render } from "./NewLine.vue?vue&type=template&id=e09387a4&scoped=true"
import script from "./NewLine.vue?vue&type=script&lang=js"
export * from "./NewLine.vue?vue&type=script&lang=js"

import "./NewLine.vue?vue&type=style&index=0&id=e09387a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e09387a4"]])

export default __exports__